<template>
  <div class="main-content sn-content">

      <el-card class="box-card">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="user-info-item">
              <div class="avatar-pic">
                <i class="el-icon-user-solid"></i>
              </div>
              <div class="user-info">
                <p>
                  <span class="tag">登录账号：</span>
                  <span class="secure-title">{{user.accountId}}</span>
                </p>
                <p>
                  <span class="tag">账号Id：</span>
                  <span class="secure-title">{{user.userId}}</span>
                </p>
                <p>
                  <span class="tag">状态：</span>
                  <span class="secure-title" v-if="user.status == '0'">正常</span>
                  <span class="secure-title" v-if="user.status == '1'">锁定</span>
                  <span class="secure-title" v-if="user.status == '2'">待审核</span>
                </p>
              </div>
            </div>



          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="user-info user-info-item">
              <p>
                <span class="tag">账号类型：</span>
                <span class="secure-title" v-if="user.role == '1'">个人账号</span>
                <span class="secure-title" v-if="user.role == '2'">企业账号</span>
                <span class="secure-title" v-if="user.role == '30'">系统用户</span>
              </p>
              <p v-if="user.role == '2'">
                <span class="tag">实名认证：</span>
                <span class="pvt-color bold" style="background: rgb(255, 107, 0,.2); margin-right: 5px;padding: 5px">企业实名认证</span>
                <router-link :to="{path:'/uac/authc'}" class="secure-title main-color ">详情</router-link>
              </p>
              <p>
                <span class="tag">注册时间：</span>
                <span class="secure-title">{{user.createDate | formatDate()}}</span>
              </p>
            </div>
          </el-col>

        </el-row>
      </el-card>

  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    methods: { },
    mounted: function () {
      // console.log(this.user)

    },
    beforeDestroy() {

    }
  }
</script>
<style>
.avatar-pic {
  width: 60px;
  height: 60px;
  background-color: #606266;
  border-radius: 50%;
  text-align: center;
  display: inline-block;
  margin-right: 50px;
}
.avatar-pic > i {
  font-size: 40px;
  color: #fff;
  line-height: 60px;
}
</style>
